import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Image, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Downarrow from "../../assets/icons/downarrow.svg";
import searchIcon from "../../assets/icons/search.svg";
import Header from "../../layouts/Header";

import {
  FetchsupplierData,
  fetchTranslationData,
} from "../../redux/actions/action";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import { axiosInstance } from "../../redux/constants/axiosInstance";
import { API_URL } from "../../redux/constants/type";
import "..//..//assets/styles/local/Supplierlist.css";
import "..//..//assets/styles/local/header.css";

import { BsChevronDown } from "react-icons/bs";
import ReactPaginate from "react-paginate";
import { Link, useHistory } from "react-router-dom";
import SupplierIcon from "../../assets/icons/supplierlist.png";
import SupplierHeader from "../../layouts/SupplierHeader";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import AddIcon from "..//..//assets/icons/addicon.svg";
import smaliIcon from "..//../assets/icons/meh.svg";
import importIcon from "../../assets/icons/shared.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import {
  showImportJobStatusNotification,
  showProductCatalogueImportNotification,
} from "../../utils/helpers/productCatalogueImportNotification";
import {
  getImportStatusSnapshot,
  getNextPollingDelay,
  hasMeaningfulImportStatusChange,
  isAllImportJobsTerminal,
} from "../../utils/helpers/importStatusPolling";

const SupplierList = () => {
  const [query, setQuery] = useState("");
  const history = useHistory();
  const selectDoc2 = useRef(null);
  const userid = window.localStorage.getItem("userid");
  const roleAccess = window.localStorage.getItem("roleid");
  const [showMemberItem, setShowMemberItem] = useState(false);
  const [filtercolumn, setFiltercolumn] = useState(false);
  const [Supplierlist, setsupplierlist] = useState([]);
  const [perPage, setPerPage] = useState(
    window.localStorage.getItem("cl-pp") || 10,
  );
  const [hovereff, setHovereff] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [modal, showModal] = useState(false);
  const [isDeletedContact, setIsDeletedContact] = useState(false);
  const [rotate, setRotate] = useState(true);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const dispatch = useDispatch();
  const companyid = window.localStorage.getItem("companyid");
  const languages = window.localStorage.getItem("language");

  const Fetchsupplier = useSelector(
    (state) => state.user.FetchSupplierListDATA,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Suppliers").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  // const DeleteContactsFetchData = useSelector((state) => state.user.DeleteContactsdata);
  // const UnlinkedContactsFetchData = useSelector((state) => state.user.CreateUnlinkContactdata);
  // const fetchTranslationDatas = useSelector((state) => state.user.FetchTranslationList);

  // const [fetchTransContactList, setFetchTransContactList] = useState([]);

  const [filterArray, setFilterArray] = useState([
    {
      id: 1,
      column: "Name",
      type: "Name",
    },
    {
      id: 2,
      column: "Telephone",
      type: "Phonenumber",
    },
    {
      id: 3,
      column: "Email",
      type: "Email",
    },
    {
      id: 4,
      column: "Contact Name",
      type: "ContactName",
    },
    {
      id: 5,
      column: "Contact Phone",
      type: "ContactPhonenumber",
    },
  ]);

  const [OrderBy, setOrderBy] = useState("ascending");
  const [Type, setType] = useState("Name");
  const [sortedItem, setSortedItem] = useState("Name");

  // useEffect(() => {
  //     document.addEventListener(
  //       "click",
  //       () => {
  //         setRotate();
  //       },
  //       true
  //     );
  //     return () => {
  //       document.removeEventListener("click", setRotate(), true);
  //     };
  //   }, []);
  // useEffect(() => {
  //     if (fetchTranslationDatas?.status === 200) {
  //         setFetchTransContactList(fetchTranslationDatas?.data?.data);
  //     }
  // }, [fetchTranslationDatas]);

  const fetchsupplierlist = useCallback(
    (perPage, currentPage, orderby, type, query) => {
      dispatch(
        FetchsupplierData(currentPage + 1, perPage, orderby, type, query),
      );
    },
    [],
  );

  useEffect(() => {
    fetchsupplierlist(perPage, currentPage, OrderBy, Type, query);
  }, []);

  useEffect(() => {
    if (Fetchsupplier != null) {
      if (Fetchsupplier?.data?.status === true) {
        setsupplierlist(Fetchsupplier?.data);
        preparePagination(Fetchsupplier?.data?.totalCount);
      }
    }
  }, [Fetchsupplier]);

  const refSupplierDropdownContainer = useRef();

  // useEffect(() => {
  //     if (DeleteContactsFetchData?.status === 200) {
  //         fetchsupplierlist(perPage, query, currentPage)
  //     }
  // }, [DeleteContactsFetchData]);

  // useEffect(() => {
  //     if (isDeletedContact === true) {
  //         setTimeout(() => {
  //             fetchsupplierlist(perPage, query, currentPage);
  //             setIsDeletedContact(false)
  //         }, 1000);
  //     }
  // }, [isDeletedContact]);

  // useEffect(() => {
  //     if (UnlinkedContactsFetchData?.status === 200) {
  //         fetchsupplierlist(perPage, query, currentPage);
  //     }
  // }, [UnlinkedContactsFetchData]);

  const isSearched = useRef(false);
  useEffect(() => {
    if (query) {
      isSearched.current = true;
      setCurrentPage(0);
      fetchsupplierlist(perPage, currentPage, OrderBy, Type, query);
      // fetchsupplierlist(perPage, query, 0)
    } else {
      if (isSearched.current) {
        isSearched.current = false;
        setCurrentPage(0);
        fetchsupplierlist(perPage, currentPage, OrderBy, Type, query);

        // fetchsupplierlist(perPage,query,0)
      }
    }
  }, [query]);

  const preparePagination = (totalRecords) => {
    const totalPages = Math.ceil(totalRecords / perPage);
    setTotalPages(totalPages);
  };

  const PaginationChange = (event) => {
    setCurrentPage(event.selected);
    // fetchsupplierlist(perPage,currentPage,OrderBy,Type,query)
    fetchsupplierlist(perPage, event.selected, OrderBy, Type, query);
  };
  const paginationMobile = (type) => {
    if (type === "next") {
      if (currentPage === totalPages - 1) {
        return;
      }
      fetchsupplierlist(perPage, currentPage + 1, OrderBy, Type, query);
      setCurrentPage(currentPage + 1);
      return;
    }

    if (currentPage === 0) {
      return;
    }
    fetchsupplierlist(perPage, currentPage - 1, OrderBy, Type, query);
    setCurrentPage(currentPage - 1);
  };

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    return setAnchorEl(null);
  };
  const hendleClick = () => {
    selectDoc2.current.click();
  };
  const docUpload3 = async (e, finalContact) => {
    const target = e.target.files[0];
    var formData = new FormData();
    formData.append("", target);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response !== null) {
        setTimeout(() => {
          axios({
            method: "post",
            url: `${API_URL}/api/Files/Adddocumenttocontact`,
            headers: {
              "Content-Type": "application/json",
            },
            data: {
              contactid: finalContact,
              userid: userid,
              docs: [
                {
                  documentname: e.target.files[0].name,
                  documentextension: e.target.files[0].type,
                  documentcontent: "string",
                  link: response.data[0],
                  documentsize: e.target.files[0].size,
                },
              ],
            },
          }).then((response) => {
            if (response?.data?.status === true) {
              setAnchorEl(null);
              window.localStorage.setItem("Doc", "Doc");
              window.localStorage.removeItem("clientaddname");
              history.push(`/contactlist/edit-contact/${finalContact}`);
            }
          });
        }, 1000);
        handleGeneralNotification(
          {
            notificationType: "CUSTOM",
            text: "Document Uploaded successfully!",
          },
          false,
        );
      }
    } catch (error) {}
  };

  const refTypeDropDownContainer = useRef();
  const handleMouseDowTypeDD = (event) => {
    if (
      refTypeDropDownContainer.current &&
      !refTypeDropDownContainer.current.contains(event.target)
    ) {
      setShowMemberItem(false);
    }
  };
  useEffect(() => {
    if (showMemberItem) {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    } else {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowTypeDD);
    };
  }, [showMemberItem]);

  const getNameAbbrivation = (firstname, lastname) => {
    const fullName = `${firstname} ${lastname}`;
    if (fullName) {
      const arr = fullName.split(" ").filter((x) => Boolean(x));
      arr.forEach((x) => {
        return x.trim();
      });
      if (arr.length > 0) {
        if (arr.length === 1) {
          return arr[0].slice(0, 2)?.toUpperCase();
        } else if (arr.length > 1) {
          return `${arr[0].slice(0, 1)?.toUpperCase()}${arr[1]
            .slice(0, 1)
            ?.toUpperCase()}`;
        }
      }
    }
  };

  const handleContactAssignTask = () => {
    setAddTaskModal(true);
    handleClose();
  };

  useEffect(() => {
    if (filtercolumn) {
      window.addEventListener("mousedown", handleMouseDownCompanyDD);
    } else {
      window.removeEventListener("mousedown", handleMouseDownCompanyDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownCompanyDD);
    };
  }, [filtercolumn]);

  const handleMouseDownCompanyDD = (event) => {
    if (
      refSupplierDropdownContainer.current &&
      !refSupplierDropdownContainer.current.contains(event.target)
    ) {
      setFiltercolumn(false);
    }
  };
  const handleFileChange = (e) => {
    const target = e.target.files[0];
    let formData = new FormData();
    formData.append("file", target);
    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response !== null) {
          setImgUrl(response.data[0]);
        }
      })
      .catch(function (error) {});
  };

  const [addTaskModal, setAddTaskModal] = useState(false);
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [length, setLength] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [showAP, setAPShow] = useState([]);
  const [maxComments, setMaxComments] = useState([]);

  const isValidActivityLog = (log) => {
    if (log.affectedColumns) {
      if (
        log.affectedColumns.length === 1 &&
        log.affectedColumns[0] === "Updatedat"
      ) {
        return false;
      }
    }
    return true;
  };

  const getActivityLog = (activity = []) => {
    const activityLogs = activity;
    let returnValue = "";
    activityLogs.every((log, index) => {
      switch (log.type) {
        case "Create":
          if (log.tableName === "Contacts") {
            if (log.newValues.Relationship) {
              returnValue = "Relationship Set";
            }
            returnValue = "Contact Created";
          }
          if (log.tableName === "Documents") {
            returnValue = "Document Attached";
          }
          if (log.tableName === "Tasks") {
            returnValue = "Task Assigned";
          }
          break;
        case "Update":
          if (log.tableName === "Contacts" && isValidActivityLog(log)) {
            if (log.newValues.Relationship) {
              returnValue = "Relationship Set";
            }
            returnValue = "Contact Updated";
          }
          if (log.tableName === "Tasks") {
            returnValue = "Task Updated";
          }
          if (log.tableName === "Clients") {
            if (log.newValues.Priceagreement) {
              returnValue = "Rate Assigned";
            }
          }
          break;
        case "Delete":
          if (log.tableName === "Tasks") {
            returnValue = "Task Deleted";
          }
          if (log.tableName === "Documents") {
            returnValue = "Document Deleted";
          }
          break;
        default:
          break;
      }
      return returnValue == "";
    });
    return returnValue;
  };

  const Rotateicon = (arrow) => {
    if (arrow === "down") {
      setRotate(false);
      setOrderBy("descending");
      fetchsupplierlist(perPage, currentPage, "descending", Type);
    } else {
      setRotate(true);
      setOrderBy("ascending");
      fetchsupplierlist(perPage, currentPage, "ascending", Type);
    }
  };
  const screenSize = useScreenSize();
  const [showClientDrop, setShowClientDrop] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [projectSearch, setProjectSearch] = useState("");

  const fileInputRef = useRef(null);
  const [excelUploadType, setExcelUploadType] = useState("");

  const importStatusPollRef = useRef(null);
  const importPollingStateRef = useRef({
    sessionId: 0,
    toastId: null,
    delayMs: 4000,
    snapshot: null,
  });

  useEffect(() => {
    return () => {
      if (importStatusPollRef.current) {
        clearTimeout(importStatusPollRef.current);
      }
    };
  }, []);

  const extractImportJobIds = (payload) => {
    const productCandidates = [
      payload?.productImportJobId,
      payload?.productJobId,
      payload?.productResponse?.body?.data?.importJobId,
      payload?.productResponse?.body?.data?.jobId,
      payload?.productResponse?.importJobId,
      payload?.data?.productImportJobId,
    ];
    const supplierCandidates = [
      payload?.supplierImportJobId,
      payload?.supplierJobId,
      payload?.supplierResponse?.body?.data?.importJobId,
      payload?.supplierResponse?.body?.data?.jobId,
      payload?.supplierResponse?.importJobId,
      payload?.data?.supplierImportJobId,
    ];

    const getFirst = (items) =>
      items.find((item) => typeof item === "string" && item.trim() !== "") ||
      "";

    return {
      product: getFirst(productCandidates),
      supplier: getFirst(supplierCandidates),
    };
  };

  const fetchImportJobStatus = async (importJobId) => {
    if (!importJobId) return null;
    const response = await axiosInstance.get(
      `${API_URL}/api/User/ImportJobStatus/${importJobId}`,
    );
    return response?.data?.data || null;
  };

  const startImportStatusPolling = async (jobIds) => {
    if (!jobIds.product && !jobIds.supplier) {
      return;
    }

    if (importStatusPollRef.current) {
      clearTimeout(importStatusPollRef.current);
    }

    const currentSessionId = Date.now();
    importPollingStateRef.current = {
      sessionId: currentSessionId,
      toastId: null,
      delayMs: 4000,
      snapshot: null,
    };

    const scheduleNextPoll = (pollFn, delayMs) => {
      importStatusPollRef.current = setTimeout(pollFn, delayMs);
    };

    const pollStatus = async () => {
      if (importPollingStateRef.current.sessionId !== currentSessionId) {
        return;
      }

      try {
        const [productStatus, supplierStatus] = await Promise.all([
          fetchImportJobStatus(jobIds.product),
          fetchImportJobStatus(jobIds.supplier),
        ]);
        const statusMap = {
          product: productStatus,
          supplier: supplierStatus,
        };
        const nextSnapshot = getImportStatusSnapshot(statusMap);
        const hadMeaningfulChange = hasMeaningfulImportStatusChange(
          importPollingStateRef.current.snapshot,
          nextSnapshot,
        );
        const allTerminal = isAllImportJobsTerminal(statusMap);

        if (
          !importPollingStateRef.current.toastId ||
          hadMeaningfulChange ||
          allTerminal
        ) {
          importPollingStateRef.current.toastId =
            showImportJobStatusNotification(
              statusMap,
              importPollingStateRef.current.toastId,
            );
        }

        importPollingStateRef.current.snapshot = nextSnapshot;
        importPollingStateRef.current.delayMs = getNextPollingDelay(
          importPollingStateRef.current.delayMs,
          hadMeaningfulChange || allTerminal,
        );

        if (allTerminal) {
          if (importStatusPollRef.current) {
            clearTimeout(importStatusPollRef.current);
            importStatusPollRef.current = null;
          }
          return;
        }
        scheduleNextPoll(pollStatus, importPollingStateRef.current.delayMs);
      } catch (error) {
        console.error("Import status polling failed:", error);
        importPollingStateRef.current.delayMs = getNextPollingDelay(
          importPollingStateRef.current.delayMs,
          false,
        );
        scheduleNextPoll(pollStatus, importPollingStateRef.current.delayMs);
      }
    };

    await pollStatus();
  };

  const handleExcelFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("file", file);
      // formData.append("excel", file);
      formData.append("productType", excelUploadType);

      // const res = await fetch(
      //   "https://automation.spire.solutions/webhook/product-catalogue",
      //   {
      //     method: "POST",
      //     body: formData,
      //   },
      // );

      const res = await axiosInstance(
        process.env.REACT_APP_SUPPLIER_CATALOGUE_API_UR,
        {
          method: "POST",
          data: formData,
        },
      );

      const responseData = res?.data || {};
      const jobIds = extractImportJobIds(responseData);

      if (jobIds.product || jobIds.supplier) {
        await startImportStatusPolling(jobIds);
      } else {
        showProductCatalogueImportNotification(responseData);
      }
    } catch (err) {
      console.error(err);
      // alert("Upload Failed");
    } finally {
      e.target.value = "";
    }
  };

  return (
    <>
      {useScreenSize() === "xs" ? (
        <Header />
      ) : (
        <SupplierHeader setQuery={setQuery} />
      )}
      {/* {addTaskModal && <ContactTaskModal
                showModal={addTaskModal}
                setTaskid={() => { }}
                setShowModal={(show, reload) => {
                    setAddTaskModal(false);
                    if (reload) {
                        window.localStorage.setItem("Task", "Task");
                        window.localStorage.removeItem("clientaddname");
                        history.push(`/contactlist/edit-contact/${finalContact}`);
                    }
                }}
                defaultContactId={finalContact}
                setComments={() => { }}
                modalFunction={"add"}
                setEnableComm={setEnableComm}
                setShowcmnt={setShowcmnt}
                enablecomm={enablecomm}
                showcmnt={showcmnt}
                setMessage={() => { }}
                message={""}
                handleFileChange={handleFileChange}
                handleAddComments={() => { }}
                maxComments={maxComments}
                show={showAP}
                length={length}
                setLength={setLength}
                setShow={setAPShow}
                imgUrl={imgUrl}
                setImgUrl={setImgUrl}
                setMaxComments={setMaxComments}
                from={moment().toDate()}
                searchText={""}
            />} */}
      <div className="parent">
        <div className="outer">
          {useScreenSize() !== "xs" && (
            <div className="sortBybox">
              <div className="sortBox">
                <div className="sortText">
                  {/* Sort By */}
                  {t("Sort By")}
                </div>
                <div>
                  <div className="upperarrowbox">
                    <div
                      className="sortbyNametext"
                      //  className={
                      //     rotate
                      //       ? "dot-rotated-supplier responsive-check sortbyNametext"
                      //       :"sortbyNametext dot-rotated-supplier-zero"
                      //   }
                      //   onClick={(event) => {
                      //     event.preventDefault();
                      //     setRotate(true);
                      //   }}
                    >
                      {rotate ? (
                        <span
                          onClick={() => {
                            Rotateicon("down");
                          }}
                        >
                          <i
                            className="fa fa-long-arrow-up"
                            style={{ fontSize: "12px" }}
                          ></i>
                        </span>
                      ) : (
                        <span
                          onClick={() => {
                            Rotateicon("up");
                          }}
                        >
                          <i
                            className="fa fa-long-arrow-down"
                            style={{ fontSize: "12px" }}
                          ></i>
                        </span>
                      )}

                      {/* <Image height={17} width={21} src={AddIcon} /> */}
                    </div>
                    <div ref={refSupplierDropdownContainer}>
                      <div
                        onClick={() => {
                          setFiltercolumn(!filtercolumn);
                        }}
                        className="sortbyNametext"
                        style={{ cursor: "pointer" }}
                      >
                        {sortedItem}
                      </div>

                      {filtercolumn && (
                        <div
                          className="filtercolumnStyle"
                          // ref={refTypeDropDownContainer}

                          id="lang-drop-down"
                        >
                          <div className="filterarrayItem">
                            {filterArray.map((item, i) => {
                              return (
                                <div className="filteritem" key={i}>
                                  <p
                                    style={{
                                      opacity: 1,
                                      paddingLeft: "8px",
                                      cursor: "pointer",
                                      color: "#323232",
                                      // fontWeight: "bold",
                                      fontWeight: `${
                                        item.column === sortedItem
                                          ? "bold"
                                          : "normal"
                                      }`,
                                    }}
                                    onClick={() => {
                                      setType(item.type);
                                      setSortedItem(item.column);
                                      setFiltercolumn(!filtercolumn);
                                      fetchsupplierlist(
                                        perPage,
                                        currentPage,
                                        OrderBy,
                                        item.type,
                                      );
                                    }}
                                    className="filterboxstyle"
                                  >
                                    {item.column}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                onClick={() => {
                  window.localStorage.removeItem("clientaddname");
                  history.push("/add-supplier");
                }}
                onMouseOver={() => setHovereff(true)}
                onMouseOut={() => setHovereff(false)}
                className={
                  roleAccess === process.env.REACT_APP_IS_VIEWER
                    ? "d-none"
                    : "d-flex add-member-btn-supplier"
                }
                style={{ borderRadius: "12px" }}
              >
                {hovereff ? (
                  <Image height={17} width={21} src={AddIcon} />
                ) : (
                  <img
                    src={SupplierIcon}
                    className="suppliers-img"
                    alt="Suppliers"
                    height={16}
                    width={20}
                  />
                  // <Image height={17} width={21} src={Conthover} />
                )}
                <p className="add-member-text ms-3 mb-0 w-100">
                  {/* Add Supplier */}
                  {t("Add Supplier")}
                </p>

                <div
                  className="ms-auto"
                  title="Import"
                  style={{ transform: "rotate(180deg)" }}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    fileInputRef.current.click();
                    setExcelUploadType("supplier");
                  }}
                >
                  <img src={importIcon} alt="" style={{ width: "14px" }} />
                </div>
              </div>
            </div>
          )}

          {/* Hidden File Input */}
          <input
            type="file"
            accept=".xlsx,.xls"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleExcelFileChange}
          />

          {useScreenSize() === "xs" && (
            <div
              style={{
                display: "flex",
                gap: "10px",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", gap: "15px" }}>
                <div
                  style={{
                    opacity: "60%",
                    color: "#7F7E7F",
                    fontWeight: "bolder",
                    fontSize: "1.1rem",
                    marginTop: "10px",
                    marginBottom: "15px",
                  }}
                >
                  {/* Stock */}
                  {t("Stock")}
                </div>
                <img
                  alt=""
                  src={Downarrow}
                  style={{
                    opacity: "60%",
                    marginTop: "18px",
                    marginBottom: "15px",
                    width: "18px",
                    height: "12px",
                    transform: "rotate(90deg)",
                    cursor: "pointer",
                  }}
                />
                <div
                  style={{
                    color: "#7F7E7F",
                    fontWeight: "bolder",
                    fontSize: "1.2rem",
                    marginTop: "10px",
                    marginBottom: "15px",
                  }}
                >
                  {/* Supplier */}
                  {t("Supplier-List")}
                </div>
              </div>
            </div>
          )}
          {screenSize === "xs" && (
            <div style={{ marginTop: "20px" }}>
              <div className="choose-project-dropdown">
                <div
                  className="project-drop-view d-flex"
                  style={{
                    justifyContent:
                      screenSize === "xs" ? "flex-start" : "space-between",
                  }}
                >
                  {screenSize === "xs" && (
                    <img className="search_pop ms-2 mb-1" src={searchIcon} />
                  )}
                  <p
                    className="margin-0-pop  ps-2"
                    onClick={() => setShowClientDrop(!showClientDrop)}
                  >
                    {selectedProject ||
                      (screenSize === "xs" ? "Search" : "Type a project ")}
                  </p>
                  {screenSize !== "xs" && (
                    <BsChevronDown
                      size={18}
                      onClick={() => setShowClientDrop(!showClientDrop)}
                      className={"down-arrow-pop bi-paperclip ms-4 ms-xxl-3"}
                    />
                  )}
                </div>

                {showClientDrop && (
                  <div className="Outer-project-dropdown">
                    <div className="project-drop d-flex justify-content-between">
                      <p className="mb-2">Choose a client</p>
                      <BsChevronDown
                        size={18}
                        onClick={() => setShowClientDrop(!showClientDrop)}
                        className={"down-arrow-pop down-arrow-rotate"}
                      />
                    </div>

                    <div
                      className="project-search-main"
                      style={{ marginBottom: "10px" }}
                    >
                      <img className="search_pop ms-2 mb-1" src={searchIcon} />
                      <input
                        type="text"
                        value={"projectSearch"}
                        style={{
                          margin: "0 0 0 0.5rem",
                          fontSie: "14px",
                        }}
                        placeholder="Search"
                        className="search-style select-client-div"
                        onChange={(e) => {
                          setProjectSearch(e.target.value);
                        }}
                      />
                    </div>
                    <div className="my-custom-scrollbar">
                      {[1, 2, 3, 4, 5]?.map((project) => {
                        return (
                          <p
                            key={project.projectid}
                            className="mb-1"
                            style={{ textTransform: "capitalize" }}
                            onClick={() => {
                              setSelectedProject(project.projectname);
                              setShowClientDrop(false);
                            }}
                          >
                            {project}
                          </p>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          <div
            className={
              screenSize === "xs"
                ? "table-responsive mt-2 member-list-dives table-contactlist-mobile ps-1"
                : "table-responsive mt-2 member-list-dives table-contactlist ps-1"
            }
          >
            {Supplierlist.data?.length ? (
              <table
                className={
                  screenSize === "xs" ? "table stock-add-table" : "table"
                }
                style={{ overflow: "scroll" }}
              >
                {screenSize === "xs" ? (
                  <tr className="hov_effects">
                    <td className="pt-3" style={{ opacity: "70%" }}>
                      {/* Name */}
                      {t("Name")}
                    </td>
                  </tr>
                ) : (
                  <thead>
                    <tr className="table-border">
                      <th className="pb-1">
                        <p
                          className="table-item mt-2"
                          style={{
                            fontWeight: "bold",
                            color: "#333333",
                            textAlign: "left",
                            paddingBottom: "10px",
                          }}
                        >
                          {/* Name */}
                          {t("Name")}
                        </p>
                      </th>
                      <th className="pb-1">
                        <p
                          className="table-item mt-2 hide-on-tablet"
                          style={{
                            fontWeight: "bold",
                            color: "#333333",
                            paddingBottom: "10px",
                          }}
                        >
                          {/* Telephone */}
                          {t("Telephone")}
                        </p>
                      </th>
                      <th className="pb-1">
                        <p
                          className="table-item mt-2"
                          style={{
                            fontWeight: "bold",
                            color: "#333333",
                            paddingBottom: "10px",
                          }}
                        >
                          {/* E-mail */}
                          {t("E-mail")}
                        </p>
                      </th>
                      <th className="pb-1">
                        <p
                          className="table-item mt-2 hide-on-tablet"
                          style={{
                            fontWeight: "bold",
                            color: "#333333",
                            paddingBottom: "10px",
                          }}
                        >
                          {/* Contact Name */}
                          {t("Contact Name")}
                        </p>
                      </th>
                      <th className="pb-1">
                        <p
                          className="table-item mt-2 hide-on-tablet"
                          style={{
                            fontWeight: "bold",
                            color: "#333333",
                            paddingBottom: "10px",
                          }}
                        >
                          {/* Contact Phone */}
                          {t("Contact Phone")}
                        </p>
                      </th>

                      {/* <th>
                      <p
                        className="table-item mt-2"
                        style={{
                          fontWeight: "bold",
                          color: "#333333",
                        }}
                      >
                        {fetchTransContactList[7]?.translation}
                      </p>
                    </th> */}
                    </tr>
                  </thead>
                )}

                <tbody>
                  {Supplierlist?.data.map((items, index) => {
                    if (screenSize === "xs") {
                      return (
                        <tr key={items.supplierid} className="hov_effects">
                          <td
                            className="pt-3"
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            {items?.suppliername}
                            <img
                              alt=""
                              src={Downarrow}
                              style={{
                                rotate: "180deg",
                                width: "18px",
                                height: "12px",
                                transform: "rotate(90deg)",
                                cursor: "pointer",
                              }}
                            />
                          </td>
                        </tr>
                      );
                    }
                    return (
                      <tr key={items.supplierid} className="hov_effects">
                        <td className="pt-3">
                          <Link
                            to={`/supplierlist/edit-supplier/${items?.supplierid}`}
                            // onClick={() => {localStorage.setItem("supplierId",items?.supplierid) }}
                            // onClick={() => {
                            //     window.localStorage.removeItem("clientaddname")
                            // }
                            // }
                            style={{
                              textDecoration: "none",
                              color: "#333333",
                              fontWeight: "600",
                            }}
                            className="title"
                          >
                            {items?.suppliername}
                          </Link>
                        </td>

                        <td className="pt-3">
                          <Link
                            to={`/supplierlist/edit-supplier/${items?.supplierid}`}
                            // onClick={() => {
                            //     window.localStorage.removeItem("clientaddname")
                            // }
                            // }
                            // onClick={() => { window.localStorage.removeItem("clientaddname") }}
                            style={{
                              textDecoration: "none",
                              // color: "#333333",
                              fontWeight: "500",
                              color: "#333333",
                            }}
                            className="title hide-on-tablet"
                          >
                            {/* {items?.phonenumber} */}
                            {items.phonenumber ? `+ ${items.phonenumber}` : ""}
                          </Link>
                        </td>
                        <td className="pt-3">
                          <Link
                            to={`/supplierlist/edit-supplier/${items?.supplierid}`}
                            // onClick={() => {
                            //     window.localStorage.removeItem("clientaddname")
                            // }
                            // }
                            // onClick={() => { window.localStorage.removeItem("clientaddname") }}
                            style={{
                              textDecoration: "none",
                              // color: "#333333",
                              fontWeight: "500",
                              color: "#333333",
                            }}
                            className="title"
                          >
                            {items?.email}
                          </Link>
                        </td>
                        <td className="pt-3">
                          {items.suppliercontact ? (
                            <Link
                              to={`/supplierlist/edit-supplier/${items?.supplierid}`}
                              // onClick={() => {
                              //     window.localStorage.removeItem("clientaddname")
                              // }
                              // }
                              // onClick={() => { window.localStorage.removeItem("clientaddname") }}
                              style={{
                                textDecoration: "none",
                                fontWeight: "500",
                                color: "#333333",
                              }}
                              className="title hide-on-tablet"
                            >
                              {items.suppliercontact.contactName}
                            </Link>
                          ) : (
                            <Link
                              to={`/supplierlist/edit-supplier/${items?.supplierid}`}
                              // onClick={() => {
                              //     window.localStorage.removeItem("clientaddname")
                              // }
                              // }
                              // onClick={() => { window.localStorage.removeItem("clientaddname") }}
                              style={{
                                textDecoration: "none",
                                fontWeight: "500",
                                color: "#333333",
                              }}
                              className="title hide-on-tablet"
                            >
                              {""}
                            </Link>
                          )}
                        </td>
                        <td className="pt-3">
                          {items.suppliercontact ? (
                            <Link
                              to={`/supplierlist/edit-supplier/${items?.supplierid}`}
                              // onClick={() => {
                              //     window.localStorage.removeItem("clientaddname")
                              // }
                              // }
                              // onClick={() => { window.localStorage.removeItem("clientaddname") }}
                              style={{
                                textDecoration: "none",
                                fontWeight: "500",
                                color: "#333333",
                              }}
                              className="title hide-on-tablet"
                            >
                              {items.suppliercontact.contactPhonenumber}
                            </Link>
                          ) : (
                            <Link
                              to={`/supplierlist/edit-supplier/${items?.supplierid}`}
                              // onClick={() => {
                              //     window.localStorage.removeItem("clientaddname")
                              // }
                              // }
                              // onClick={() => { window.localStorage.removeItem("clientaddname") }}
                              style={{
                                textDecoration: "none",
                                fontWeight: "500",
                                color: "#333333",
                              }}
                              className="title hide-on-tablet"
                            >
                              {""}
                            </Link>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div style={{ height: "60vh" }}>
                <div
                  className="d-flex mt-3"
                  style={{ justifyContent: "space-between" }}
                >
                  <p
                    className="ms-4 table-item mt-2"
                    style={{
                      fontWeight: "bold",
                      color: "#333333",
                      fontSize: "14px",
                    }}
                  >
                    {/* Name */}
                    {t("Name")}
                  </p>
                  <p
                    className="ms-4 table-item mt-2"
                    style={{
                      fontWeight: "bold",
                      color: "#333333",
                      fontSize: "14px",
                    }}
                  >
                    {/* Telephone */}
                    {t("Telephone")}
                  </p>
                  <p
                    className="ms-4 table-item mt-2"
                    style={{
                      fontWeight: "bold",
                      color: "#333333",
                      fontSize: "14px",
                    }}
                  >
                    {/* E-mail */}
                    {t("E-mail")}
                  </p>
                  <p
                    className="ms-4 table-item mt-2"
                    style={{
                      fontWeight: "bold",
                      color: "#333333",
                      fontSize: "14px",
                    }}
                  >
                    {/* Contact Name */}
                    {t("Contact Name")}
                  </p>
                  <p
                    className="ms-4 table-item mt-2"
                    style={{
                      fontWeight: "bold",
                      color: "#333333",
                      fontSize: "14px",
                    }}
                  >
                    {/* Contact Phone */}
                    {t("Contact Phone")}
                  </p>
                </div>
                <div className="row container mt-5 pt-5">
                  <img
                    src={smaliIcon}
                    alt="smali"
                    width={35}
                    height={35}
                    className="mt-5 "
                  />
                  <h6
                    className="mt-1"
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                      textAlign: "center",
                      color: "#707070",
                    }}
                  >
                    {/* Sorry. */}
                    {t("Contact Phone")}
                    <br />
                    {/* No results for your criteria. */}
                    {t("No results for your criteria.")}
                    <br />
                    {/* Try to refine your search or enter a new search. */}
                    {t('\"Try to refine your search  or enter a new search.\"')}
                  </h6>
                </div>
              </div>
            )}
          </div>

          {screenSize === "xs" ? (
            <div
              style={{
                position: "fixed",
                bottom: "0",
                marginBottom: "15px",
                width: "100%",
                background: "#fafafa",
              }}
            >
              <section
                style={{
                  width: "90%",
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                  marginBottom: "25px",
                }}
              >
                <div style={{ display: "flex", gap: "10px" }}>
                  <img
                    alt=""
                    src={Downarrow}
                    onClick={() => paginationMobile()}
                    style={{
                      marginTop: "3px",
                      width: "18px",
                      height: "12px",
                      transform: "rotate(90deg)",
                      cursor: "pointer",
                      opacity: currentPage === 0 ? "50%" : "100%",
                      pointerEvents: currentPage === 0 ? "none" : "all",
                    }}
                  />
                  <p className="previous-week-text">Present Page</p>
                </div>
                <div style={{ display: "flex", gap: "10px" }}>
                  <p className="present-week-text">Previous Page</p>
                  <img
                    alt=""
                    src={Downarrow}
                    onClick={() => paginationMobile("next")}
                    style={{
                      width: "18px",
                      marginTop: "3px",
                      height: "12px",
                      transform: "rotate(-90deg)",
                      cursor: "pointer",
                      opacity: currentPage === totalPages - 1 ? "50%" : "100%",
                      pointerEvents:
                        currentPage === totalPages - 1 ? "none" : "all",
                    }}
                  />
                </div>
              </section>
              <div style={{ width: "90%" }}>
                <button
                  style={{ width: "100%" }}
                  className="worktime-add-btn frc"
                  onClick={() => {}}
                >
                  <img
                    alt=""
                    src={SupplierIcon}
                    style={{
                      width: "30px",
                      height: "30px",
                    }}
                  />
                  {/* <p>Add Supplier</p> */}
                  <p>{t("Add Supplier")}</p>
                </button>
              </div>
            </div>
          ) : (
            <div>
              <Row>
                <Col xl={9}>
                  <p
                    className="fw-bold mt-3 "
                    style={{
                      fontSize: "20px",
                      color: "#333333",
                      display: "flex",
                    }}
                  >
                    <p
                      className="table-item mt-1"
                      style={{
                        fontWeight: 400,
                        fontSize: "clamp(10px, 0.729vw, 1vw)",
                      }}
                    >
                      {/* {fetchTransContactList[4]?.translation} */}
                      {/* Items Per Page */}
                      {t("Items Per Page")}
                    </p>
                    <div
                      style={{
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "5px",
                      }}
                      className="ms-4"
                    >
                      <p
                        className="margin-0"
                        style={{
                          fontSize: "clamp(10px, 0.729vw, 1vw)",
                          fontWeight: "bold",
                          color: "#333333",
                          flexGrow: "1",
                          textTransform: "capitalize",
                        }}
                        onClick={() => setShowMemberItem(!showMemberItem)}
                      >
                        {perPage}
                      </p>
                      <BsChevronDown
                        size={10}
                        style={{
                          flexGlow: "1",
                          color: "#333333",
                        }}
                        onClick={() => setShowMemberItem(!showMemberItem)}
                        className="down-arrow bi-paperclip ms-2 mt-1"
                      />
                      {showMemberItem && (
                        <div
                          className="dropdown-supplier d-flex align-items-end p-1"
                          ref={refTypeDropDownContainer}
                          id="lang-drop-down"
                        >
                          <div>
                            {[10, 20, 50]?.map((item, i) => {
                              return (
                                <div>
                                  <p
                                    key={i}
                                    className="margin-0 ms-2 pb-1 items-page-number-screen"
                                    style={{
                                      opacity: 1,

                                      // fontWeight: "bold",
                                      fontWeight: `${
                                        item === perPage ? "800" : "bold"
                                      }`,
                                      color: `${
                                        item === perPage ? "#95A7C6" : "#333333"
                                      }`,
                                    }}
                                    onClick={() => {
                                      window.localStorage.setItem(
                                        "cl-pp-supplier",
                                        item,
                                      );
                                      setPerPage(item);
                                      setCurrentPage(0);
                                      setShowMemberItem(false);
                                      fetchsupplierlist(item, 0, OrderBy, Type);
                                    }}
                                  >
                                    {item}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                          <BsChevronDown
                            size={10}
                            style={{
                              fontWeight: "bold",
                              flexGlow: "1",
                              color: "#333333",
                            }}
                            className="mb-1 ms-1 down-arrow down-arrow-rotate bi-paperclip"
                          />
                        </div>
                      )}
                    </div>
                  </p>
                </Col>
                <Col xl={3} className="add-col-item">
                  <div className="table-filter-info">
                    <ReactPaginate
                      nextLabel=""
                      forcePage={currentPage}
                      disableInitialCallback={true}
                      onPageChange={PaginationChange}
                      pageRangeDisplayed={3}
                      marginPagesDisplayed={1}
                      pageCount={totalPages}
                      previousLabel=""
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="d-none"
                      nextClassName="d-none"
                      breakLabel="..."
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      containerClassName="app-paginations"
                      activeClassName="active"
                      renderOnZeroPageCount={null}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SupplierList;
